import { render, staticRenderFns } from "./MS365AtRest.vue?vue&type=template&id=52f823a0&"
import script from "./MS365AtRest.vue?vue&type=script&lang=ts&"
export * from "./MS365AtRest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports